'use client';

import { type ReactNode, createContext, useRef, useContext } from 'react';
import { useStore } from 'zustand';
import { WidgetStore, createWidgetStore } from '@/stores/widget';

export type WidgetStoreApi = ReturnType<typeof createWidgetStore>;

export const WidgetStoreContext = createContext<WidgetStoreApi | undefined>(
  undefined,
);

export interface WidgetStoreProviderProps {
  children: ReactNode;
}

export const WidgetStoreProvider = ({ children }: WidgetStoreProviderProps) => {
  const storeRef = useRef<WidgetStoreApi>(createWidgetStore() ?? null);

  return (
    <WidgetStoreContext.Provider value={storeRef.current}>
      {children}
    </WidgetStoreContext.Provider>
  );
};

export const useWidgetStore = <T,>(selector: (store: WidgetStore) => T): T => {
  const widgetStoreContext = useContext(WidgetStoreContext);

  if (!widgetStoreContext) {
    throw new Error(`useWidgetStore must be used within WidgetStoreProvider`);
  }

  return useStore(widgetStoreContext, selector);
};
